export default "__VITE_ASSET__Dg3FG3nS__"